import { useContext } from 'react';

import { BrandAccentColorContext } from './BrandAccentColorContext';

export const useBrandAccentColorContext = () => useContext(BrandAccentColorContext);
